import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addNameForTheForm,
  getSelectedFormEditorForm,
} from '../../../store/slices/formEditorSlice';

export const SetNameForForm = () => {
  const dispatch = useDispatch();
  const selectedForm = useSelector(getSelectedFormEditorForm);
  const [formName, setFormName] = useState('');

  useEffect(() => {
    if (!selectedForm) return;
    if (!selectedForm.name) return;
    if (!selectedForm.id) return;

    if (formName !== selectedForm.name) {
      setFormName(selectedForm.name);
    }
  }, [selectedForm]);

  const handleInputChange = (e) => {
    const newName = e.target.value;
    setFormName(newName);

    if (selectedForm?.name !== newName) {
      dispatch(addNameForTheForm(newName));
    }
  };

  return (
    <>
      {selectedForm?.id && (
        <input
          type="text"
          value={formName}
          onChange={handleInputChange}
          placeholder="Syötä nimi…"
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 10,
            border: '1px solid rgba(255,255,255,0.15)',
            background: 'rgba(255,255,255,0.06)',
            color: '#fff',
            outline: 'none',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#007bff')}
          onBlur={(e) => (e.target.style.borderColor = '#ccc')}
        />
      )}
    </>
  );
};
